/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Company_Profile_Add_Social_Media_ButtonInputs */

const en_company_profile_add_social_media_button = /** @type {(inputs: Company_Profile_Add_Social_Media_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Add Social Media Link`)
};

const de_company_profile_add_social_media_button = /** @type {(inputs: Company_Profile_Add_Social_Media_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Social Media Link hinzufügen`)
};

/**
* | output |
* | --- |
* | "Add Social Media Link" |
*
* @param {Company_Profile_Add_Social_Media_ButtonInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const company_profile_add_social_media_button = /** @type {((inputs?: Company_Profile_Add_Social_Media_ButtonInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Company_Profile_Add_Social_Media_ButtonInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_company_profile_add_social_media_button(inputs)
	return en_company_profile_add_social_media_button(inputs)
});